import { productKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

export const removeProductKnowledge = {
  name: "removeProductKnowledge" as const,
  input: z.object({ ids: z.array(productKnowledgeIdFormat.schema) }).strict(),
  output: z.object({
    /** Ids that were missing or already removed count as not removed. */
    removedCount: z.number(),
  }),
};
